<template>
  <a-layout class="main__container">
    <div class="banner">
      <img v-if="!eventCover" src="../assets/home/icon_img29.png" alt="" />
      <img v-else :src="eventCover" alt="" />
    </div>
    <div class="tit">
      <div class="tit_name">
        赛事资讯
      </div>
      <div class="tit_en">
        The relevant information
      </div>
    </div>
    <div class="list">
      <div
        class="item"
        v-for="(item, index) in newsList"
        :key="index"
        @click="detail(item.id)"
      >
        <img :src="item.cover" alt="" />
        <div class="info">
          <div class="info_t">
            {{ item.title }}
          </div>
          <div class="info_txt">
            <div class="txt">
              {{ item.content }}
            </div>
          </div>
          <div class="info_b">
            <div class="name">{{ item.organizer }}</div>
            <div class="date">{{ item.createTime }}</div>
          </div>
        </div>
      </div>
    </div>
  </a-layout>
</template>

<script>
import { getGameNewsList } from "@/api";

export default {
  name: "GamePageDetail",
  data() {
    return {
      id: this.$route.query.id,
      newsList: [],
      eventCover: "",
    };
  },
  created() {
    this.getNewsList();
  },
  methods: {
    async getNewsList() {
      const { data } = await getGameNewsList({
        id: this.$route.query.id,
      });
      this.newsList = data.data;
      if (this.newsList.length > 0) {
        this.eventCover = this.newsList[0].eventCover;
      }
    },
    detail(id) {
      this.$router.push({
        name: "InformationDetail",
        query: { id },
      });
    },
  },
};
</script>

<style scoped lang="less">
.main__container {
  padding-top: 72px;
  background-color: #eef0f3;
  .banner {
    img {
      width: 100%;
      height: 400px;
      object-fit: cover;
    }
  }
  .tit {
    margin-top: 52px;
    text-align: center;
    .tit_name {
      font-weight: 600;
      font-size: 24px;
      color: rgba(0, 0, 0, 0.85);
    }
    .tit_en {
      font-weight: 600;
      font-size: 18px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  .list {
    width: 1150px;
    margin: 0 auto 100px;
    .item {
      display: flex;
      align-items: center;
      margin-top: 32px;
      cursor: pointer;
      img {
        width: 226px;
        height: 168px;
        object-fit: cover;
      }
      .info {
        padding: 12px 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 168px;
        flex-grow: 1;
        .info_t {
          font-weight: 600;
          font-size: 18px;
          color: rgba(0, 0, 0, 0.85);
          display: -webkit-box;
          -webkit-line-clamp: 1; /* 设置显示的行数 */
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .info_txt {
          font-weight: 400;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          flex: 1;
          margin-top: 12px;
          .txt {
            display: -webkit-box;
            -webkit-line-clamp: 3; /* 设置显示的行数 */
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .info_b {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-weight: 400;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
        }
      }
    }
  }
}
</style>
